import { Component, Host, h, Prop, Element } from '@stencil/core';
import { randomRGB } from '../../utils/random';

export interface AhaCalendarEventDot extends HTMLAhaCalendarEventDotElement {}

@Component({
  tag: 'aha-calendar-event-dot',
  styleUrl: 'aha-calendar-event-dot.css',
  shadow: true,
})
export class AhaCalendarEventDot {
  @Element() host!: HTMLAhaCalendarEventDotElement;

  /** Color of dot. */
  @Prop({ reflect: true }) color: string = randomRGB();

  render() {
    return (
      <Host>
        <div id="dot" part="dot" style={{ backgroundColor: this.color }}></div>
      </Host>
    );
  }
}
